import { employeeReducer } from "./employee/employee-reducer";
import { serviceReducer } from "./services/services-reducer";
import {amenitiesReducer} from './amenities/amenities-reducer'
import {subscriptionReducer} from "./subscription/subscription-reducer"
import { branchReducer } from "./branch/branch-reducer";
import { partnerReducer } from "./partner/partner-reducer";
import { harmoniProfileReducer } from "./harmoni-profile/profile-reducer";
import { categoryReducer } from "./category/category-reducer";
import { subCategoryReducer } from "./sub-category/sub-category-reducer";
import { packagesReducer } from "./packages/packages-reducer";
import { partnerEmployeeReducer } from "./partner-employee/partner-employee-reducer";
import { partnerStaffReducer } from "./partner-staff/partner-staff-reducer";



export const HARMONI_ROOT_REDUCER={
    employees: employeeReducer,
    services:serviceReducer,
    amenities:amenitiesReducer,
    subscription:subscriptionReducer,
    partner:partnerReducer,
    branch:branchReducer,
    profileInfo:harmoniProfileReducer,
    category:categoryReducer,
    subcategory:subCategoryReducer,
    packages:packagesReducer,
    partneremployees:partnerEmployeeReducer,
    partnerStaff:partnerStaffReducer

}